/* The Pillow Drop: one-tap "+ Add" on the cart drawer's "You might also like" cards. */
(function () {
  if (window.tpdCartAddBound) return;
  window.tpdCartAddBound = true;
  document.addEventListener('click', function (ev) {
    var arrow = ev.target.closest && ev.target.closest('[data-tpd-cs-scroll]');
    if (arrow) {
      var box = arrow.closest('.wt-cart__cross-sell');
      var track = box && box.querySelector('[data-tpd-cs-track]');
      if (track) track.scrollBy({ left: track.clientWidth * 0.85 * Number(arrow.getAttribute('data-tpd-cs-scroll')), behavior: 'smooth' });
      return;
    }
    var btn = ev.target.closest && ev.target.closest('[data-tpd-cs-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-tpd-cs-add')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.textContent = 'Sold out'; return; }
        btn.textContent = 'Added ✓';
        if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents({ sections: res.j.sections }, false); return; } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      })
      .catch(function () { btn.textContent = label; btn.disabled = false; });
  });
  /* Let an ordinary vertical mouse wheel move the row sideways too. Trackpads and touch scroll it natively. */
  document.addEventListener('wheel', function (ev) {
    var track = ev.target.closest && ev.target.closest('[data-tpd-cs-track]');
    if (!track || Math.abs(ev.deltaX) > Math.abs(ev.deltaY)) return;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 0) return;
    if ((ev.deltaY < 0 && track.scrollLeft <= 0) || (ev.deltaY > 0 && track.scrollLeft >= max - 1)) return;
    ev.preventDefault();
    track.scrollLeft += ev.deltaY;
  }, { passive: false });
})();